<template>
  <div class="marking" v-loading="submitLoading">
    <div class="marking-header-btn">
      <div class="marking-header-btn-all">
        <el-button class="return" @click="handleReturn()">返回</el-button>
        <el-button class="save" @click="saveHomeWork()" v-show="saveShow">提交</el-button>
        <el-button class="marking"
          v-if="allData.approvalMode > 0 && allData.approvalMode != 2 && (allData.approvalStatus == 2 || allData.approvalStatus == 8)" @click="show"
          v-show="!saveShow && !markBtn && checkHomeMarking()" :disabled="markBtn">
          <div class="mark">作业批改</div>
        </el-button>
        <el-button class="marking-end"
          v-if="allData.approvalMode > 0 && allData.approvalMode != 2 && (allData.approvalStatus == 2 || allData.approvalStatus == 8)" @click="show"
          v-show="markBtn && checkHomeMarking()" :disabled="markBtn">
          <div class="mark">作业批改</div>
        </el-button>
      </div>
    </div>
    <div class="approval" v-if="allData.approvalMode > 0">
      <div class="step1 step" v-for="(item, index) in setpObj[allData.approvalMode]" :key="index">
        <div class="img" :class="{
            'img0': index == 0,
            'img1': index == 1,
            'img2': index == 2,
            'img3': [20, 6, 7, 35, 11].indexOf(allData.approvalStatus) < 0 && index == 0,
            'img4': ([2, 3, 8, 9, 30, 40].indexOf(allData.approvalStatus) > -1 && index == 1 && [3,5].indexOf(allData.approvalMode) > -1)
            || ([2, 3, 8, 9, 30, 40].indexOf(allData.approvalStatus) > -1 && index == 1 && [2,4].indexOf(allData.approvalMode) > -1),

            'img5': ([3, 40].indexOf(allData.approvalStatus) > -1 && index == 1 && [1,4].indexOf(allData.approvalMode) > -1)
                || ([3, 40].indexOf(allData.approvalStatus) > -1 && index == 2 && [3,5].indexOf(allData.approvalMode) > -1),

            'img7': ([2, 8, 9, 30].indexOf(allData.approvalStatus) > -1 && index == 1 && [1, 4].indexOf(allData.approvalMode) > -1) ||
                    ([2, 8, 9].indexOf(allData.approvalStatus) > -1 && index == 2 && [5,3].indexOf(allData.approvalMode) > -1)
                      || (allData.approvalStatus == 1 && index == 1 && [2,3,5].indexOf(allData.approvalMode) > -1),
        }"></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <!-- <btn></btn> -->
    <!-- 课程编号 -->
    <div class="marking-status">
      <div class="marking-status-content">
        <div class="marking-status-content-first">
          <div class="title">课程编号:</div>
          <div class="content">{{ allData.courseCode }}</div>
        </div>
        <!-- 隔离线 -->
        <div class="image-solate"></div>
        <div class="marking-status-content-second">
          <div class="content-all">
            <div class="title">创建人:</div>
            <div class="content">{{ allData.createName }}</div>
          </div>

          <div class="content-all">
            <div class="title">创建时间:</div>
            <div class="content">{{ formatDate(allData.createTime) }}</div>
          </div>
          <div class="content-all">
            <div class="title">修改人:</div>
            <div class="content">{{ allData.updateName }}</div>
          </div>
        </div>
        <!--隔离线 -->
        <div class="image-solate"></div>
        <div class="marking-status-content-thired">
          <div class="title">作业状态:</div>
          <div class="content">
            <span class="statusBox"
              :class="{ 'statusWarn': [1, 2,8,9, 30].indexOf(allData.approvalStatus) > -1, 'statusSuccess': [3, 5, 40].indexOf(allData.approvalStatus) > -1, 'statusFail': [4, 6, 7,11, 50, 35].indexOf(allData.approvalStatus) > -1 }"></span>
            {{ approveType[allData.approvalStatus] }}
          </div>
        </div>
      </div>
    </div>

    <!-- 基本信息 -->
    <ShowDetails :title="'基本信息'" :showBtn="false" :showContent="true">
      <el-form label-position="left" label-width="90px">
        <el-row class="margb10">
          <el-col :span="8" class="padt5">
            <el-form-item label="姓名:">
              {{ allData.realName }}({{ allData.account }})
            </el-form-item>
          </el-col>
          <el-col :span="8" class="padt5">
            <el-form-item label="所在经销商:">
              {{ allData.dealerName }}
            </el-form-item>
          </el-col>
          <el-col :span="8" class="padt5">
            <el-form-item label="联系电话:">
              {{ allData.phone }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margb10">
          <el-col :span="8" class="padt5">
            <el-form-item label="联系邮箱:">
              {{ allData.email }}
            </el-form-item>
          </el-col>
          <el-col :span="8" class="padt5">
            <el-form-item label="作业标题:">
              {{ allData.homeworkName }}
            </el-form-item>
          </el-col>
          <el-col :span="8" class="padt5">
            <el-form-item label="提交时间:">
              {{ formatDate(allData.pubDate) }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </ShowDetails>

    <!-- 作业描述 -->
    <ShowDetails title="作业描述" :showBtn="true" :showContent="true">
      <el-form label-position="left" style="margin-left:12px" label-width="80px">
        <el-form-item label="说明文件" v-if="allData && allData.resourceVOList.length">
          <div v-for="(item, index) in allData.resourceVOList" :key="index" class="lineBox1"
            @click="seeView(item.resource)">
            {{ item.resourceName }}
          </div>
        </el-form-item>
        <el-form-item label="作业描述">
          <div v-for="(item, index) in homeworkContent.content" :key="index" class="lineBox">
            <div v-if="item.type == 1">
              {{ item.value }}
            </div>
            <div v-if="item.type == 2">
              <div class="content-pic">
                <img style="width: 292px; height: 134px" :src="item.value" alt="" @click="previewImg1(item.value)" />
              </div>
            </div>
            <div v-if="item.type == 3">
              <video id="myVideo" class="video-js" controls="controls">
                <source :src="item.value" type="video/mp4" />
              </video>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </ShowDetails>
    <ShowDetails title="作业内容" :showBtn="true" :showContent="true">
      <el-form label-position="left" style="margin-left:12px" label-width="80px">
        <div v-for="(item, index) in planList" :key="index">
          <el-form-item v-if="item.type == 1 && item.value.length" label="文字信息">
            <div v-for="(ite, j) in item.value" :key="j">
              {{ ite.content }}
            </div>
          </el-form-item>
          <el-form-item v-if="item.type == 4 && item.value.length" label="网盘地址">
            <div v-for="(ite, j) in item.value" :key="j">
              {{ ite.content }}
            </div>
          </el-form-item>
          <el-form-item v-if="item.type == 3 && item.value.length" label="附件">
            <el-button type="primary" size="small" @click="downAll()" style="margin-bottom: 10px">批量下载</el-button>
            <div class="viewItem" v-for="(ite, j) in item.value" :key="j">
              <div>{{ ite.name }}</div>
              <em class="el-icon-view viewItemIcon" v-if="ite.contentType == 2" @click="previewImg(ite.content)"></em>
              <em class="el-icon-view viewItemIcon" v-if="ite.contentType != 6 && ite.contentType != 2" @click="seeView(ite.content)"></em>
              <em class="el-icon-download viewItemIcon" @click="downloadFile(ite.content, ite.contentType)"></em>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </ShowDetails>
    <!-- 作业内容结束 -->
    <ShowDetails :title="'审批历史'" :showBtn="true" :showContent="false"
      v-if="allData.approvalMode > 0 && allData.approvalStatus != 5">
      <div class="tableBox">
        <div class="titleBox">
          <div class="tableBoxTitleFirst">操作步骤</div>
          <div class="tableBoxTitle">操作用户</div>
          <div class="tableBoxTitle">职位</div>
          <div class="tableBoxTitle">审批状态</div>
          <div class="tableBoxTitle">操作时间</div>
          <div class="tableBoxTitleLast">操作</div>
        </div>
        <div class="contentBox" v-if="historyData.length">
          <TableLine v-for="(item, index) in historyData" :key="index" :data="item" @down="homeworkDownIDS"
            :courseId="allData && allData.homeworkSubmitId ? allData.homeworkSubmitId : null" :businessType="1"></TableLine>
        </div>
      </div>
    </ShowDetails>
    <!-- 附件下载结束 -->
    <!-- 作业审批开始 -->
    <div class="homework-processes"
      v-if="allData.approvalMode > 0 && allData.approvalMode != 2 && (allData.approvalStatus == 2 || allData.approvalStatus == 8)">
      <div class="ess-information-title">
        <div class="line"></div>
        <div class="title">作业审批</div>
      </div>
      <!-- 隔离线 -->
      <div class="isolate"></div>
      <!-- 隔离线 -->
      <div class="processes-result">
        <div class="result-title">
          <div class="img">
            <img src="@/assets/img/course/warning.png" alt="" />
          </div>
          <div class="title">审批结果</div>
        </div>
        <div class="result-content">
          <template>
            <el-radio-group v-model="checkResult" :disabled="showMarking" @change="radioChange">
              <el-radio :label="1">完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </template>
        </div>
      </div>
      <div class="processes-grade" v-show="this.checkResult == 1">
        <div class="grade-title">
          <div class="img">
            <img src="@/assets/img/course/warning.png" alt="" />
          </div>
          <div class="title">分数</div>
        </div>
        <div class="grade-content">
          <el-input oninput="value=value.replace(/[^0-9.]/g,'')" maxlength="3"
            :disabled="showMarking" class="content" placeholder="请输入60-100之间的分数" v-model.number="homeworkScore"></el-input>
        </div>
      </div>
      <div class="processes-reason">
        <div class="grade-title1" :style="{ marginLeft: this.checkResult == 0 ? '-12px' : '0'}">
          <div class="img" v-show="this.checkResult == 0">
            <img src="@/assets/img/course/warning.png" alt="" />
          </div>
          <div class="title">审批反馈</div>
        </div>
        <!-- <div class="reason-title">审批反馈</div> -->
        <div class="reason-content">
          <el-input size="medium " :disabled="showMarking" v-model="homeworkCheck" style="margin: 6px 0px 6px 0px"
            type="textarea" maxlength="500" show-word-limit placeholder="请描述该作业被驳回需要重新提交的原因以便让学员知悉。"></el-input>
        </div>
      </div>
      <div class="processes-upload" v-if="saveShow">
        <el-upload ref="coverUpload" :on-remove="handleRemove" :on-preview="handlePreview" :action="imgAction"
          :headers="headers" :file-list="fileList" :http-request="httpRequestCover">
          <div>
            <!--  <em class="el-icon-document"></em> -->
            <img src="@/assets/img/job/file.png" class="fileIcon" alt="" />
            上传文件
          </div>
        </el-upload>
      </div>
    </div>

    <!-- 返回弹窗 -->
    <el-dialog :visible.sync="dialogVisibleReurn" custom-class="dialogVisibleReurnResource">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">
          返回上一级,信息不会被保存,确认返回吗？
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReurn = false" class="dialog-footer-btn">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="tabRemove()" class="dialog-footer-btn">确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleDownLoad" custom-class="dialogVisibleReurnResource">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">
          是否下载Zip作业文件【{{ this.homeworkName }}】？
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDownLoad = false" class="dialog-footer-btn">取 消</el-button>
        <el-button type="primary" style="margin-left: 16px" @click="homeworkDownIDSResult()" class="dialog-footer-btn">确
          定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="saveDataVisible" custom-class="dialogVisibleReurnResource">
      <div class="dialog-modl">
        <div>
          <img src="@/assets/img/course/dialogIcon.png" alt="" />
        </div>
        <div class="dialog-modl-right">
          {{ checkResult == 1 ? "确定审批通过吗？" : "确定审批不通过吗？" }}
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveDataVisible = false" class="dialog-footer-btn">取 消</el-button>
        <el-button type="primary" v-loading="submitLoading" :disabled="submitLoading" style="margin-left: 16px" @click="saveDataVisibleFun()" class="dialog-footer-btn">确
          定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import moment from 'moment'
import myVideo from '@/components/course/Video.vue'
import ShowDetails from '@/components/show-details'
import TableLine from '@/components/table-line'
import Vue from 'vue'
// 需要添加的配置
export default {
  data() {
    return {
      saveDataVisible: false,
      dialogVisibleDownLoad: false,
      downloadUrl: "",
      homeworkName: "",
      submitLoading: false,
      courseId: "",
      markBtn: false,
      saveShow: false,
      showMarking: true,
      homeworkCheck: '',
      homeworkScore: '',
      homeworkCloud: [],
      homeworkVideo: [],
      homeworkPic: [],
      wordExplain: [],
      homeFileLoadURL: [],
      homeFileLoad: [],

      historyData: [],
      checkResult: 0,
      homeworkSubmitId: '',
      allData: null,
      approveType: {
        1: '待店内审批',
        2: '待培训师审批',
        3: '已审批',
        4: '逾期未提交',
        5: '无需审核通过',
        6: '店内审批未通过待提交',
        7: '培训师审批未通过待提交',
        8: '待培训师和区域经理审批',
        9: '待区域经理审批',
        11: '区域经理审批未通过待提交',
        20: '待提交',
        30: '待培训师审批',
        35: '未通过待提交',
        40: '已审批',
        50: '逾期未提交',
      },
      setpObj: {
        1: [
          {
            name: '用户提交',
          },
          {
            name: '培训师审批',
          },
        ],
        4: [
          {
            name: '用户提交',
          },
          {
            name: '培训师及区域经理审批',
          },
        ],
        2: [
          {
            name: '用户提交',
          },
          {
            name: '店内审批',
          },
        ],
        3: [
          {
            name: '用户提交',

          },
          {
            name: '店内审批',

          },
          {
            name: '培训师审批',

          },
        ],
        5: [
          {
            name: '用户提交',

          },
          {
            name: '店内审批',

          },
          {
            name: '培训师及区域经理审批',

          },
        ],
      },
      rowData: {},
      homeworkContents: '',
      homeworkContent: [],
      planList: [],
      dialogVisibleReurn: false,
      fileList: [],
      imgAction: window.SITE_CONFIG['apiBaseURL'] + '/rm/file/fileUpload',
      homeworkDownloadId: '',
      imgList: [],
    }
  },
  computed: {
    // 获取请求头
    headers: function headers() {
      let headersObj = {
        token: Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
      }
      return headersObj
    }
  },
  methods: {
    radioChange(val) {
      console.log(val)
      if (val == 1) {
        this.homeworkScore = ''
      } else {
        this.homeworkScore = ''
      }
    },
    handlePreview(file) {
      window.open(file.fileUrl);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    httpRequestCover(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      this.$request
        .post(
          `/file/uploadFile?fileName=${params.file.name}&containerName=resource&type=${this.checkFile(params.file.name)}`,
          formData
        )
        .then((res) => {
          this.fileList.push({ fileUrl: res, fileName: params.file.name, name: params.file.name, fileType: this.checkFile(params.file.name) });
        }).catch((err) => {
          console.log(err);
        })
    },
    checkFile(fileValue) {
      let index = fileValue.lastIndexOf("."); //（考虑严谨用lastIndexOf(".")得到）得到"."在第几位
      let fileValueSuffix = fileValue.substring(index); //截断"."之前的，得到后缀
      if (/(.*)\.(mp4|avi|wmv|MP4|AVI|WMV|mov|MOV)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合视频格式
        return 3;
      } else if (/(.*)\.(png|jpg|jpeg)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合图片格式
        return 2;
      } else if (/(.*)\.(pdf|PDF)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
        return 5;
      } else if (/(.*)\.(mp3|MP3|wav|m4a)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
        return 7;
      } else if (/(.*)\.(xls|PPT|PPTX|ppt|pptx|XLS|xlsx|XLSX|doc|DOC|docx|DOCX|zip|rar)$/.test(fileValueSuffix)) { //根据后缀，判断是否符合OFFICE格式
        return 6;
      }
      return 6;
    },
    seeView(url) {
      window.open(url, '_blank')
    },
    downloadFile(url, name) {
      window.open(`${window.SITE_CONFIG['apiURL']}/course/downloadAttachment?fileUrl=` + encodeURIComponent(decodeURIComponent(url)), '_blank');
    },
    seeImgView() {},
    // 作业批改
    checkHomeMarking() {
      if (this.$hasPermission('joy:learning:courseoperation:workmarking')) {
        return true
      }
      return false
    },
    // 保存
    checkHomeSave() {
      if (this.$hasPermission('joy:learning:courseoperation:save')) {
        return true
      }
      return false
    },
    // 返回删除meta
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      )
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName =
          this.$store.state.contentTabsActiveName = 'home'
        return false
      } // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name,
        })
      }

      const courseId = this.courseId
      this.$router.push({
        path: "/operationView",
        query: { courseId: courseId },
      });
      this.$eventHub.$emit("courseId", courseId);

    },
    // 返回弹窗
    handleReturn() {
      if (this.showMarking) {
        this.tabRemove();
      } else {
        this.dialogVisibleReurn = true
      }
    },
    // 作业修改保存
    saveHomeWork() {
      this.dataListLoading = true;
      if ((this.homeworkScore < 60 || this.homeworkScore > 100) && this.checkResult == 1) {
        this.$message.warning("请输入60-100之间的分数")
        return;
      }
      if (this.checkResult == 0 && this.homeworkCheck == '') {
        this.$message.warning("请输入审批反馈")
        return;
      }
      if (this.checkResult == 0) {
        this.homeworkScore = 0
      }
      this.saveDataVisible = true;
    },
    saveDataVisibleFun() {
      this.submitLoading = true;
      this.$request
        .post('/course/homework/saveHomeworkCheck', {
          homeworkSubmitId: this.homeworkSubmitId,
          score: this.homeworkScore,
          checkResult: this.checkResult,
          homeworkCheck: this.homeworkCheck,
          feedbackFileList: this.fileList,
        })
        .then((res) => {
          if (res) {
            this.saveDataVisible = false;
            this.saveShow = false
            this.showMarking = true
            this.homeworkScore = ''
            this.dataListLoading = false
            this.$message.success('保存成功')
            this.historyData = [];
            this.getData()
            this.submitLoading = false;
          }
        })
    },
    show() {
      this.saveShow = true
      this.showMarking = false
      if (this.allData.checkResult != 0 && this.allData.checkResult != 1) {
        this.checkResult = 1
      }
      this.homeworkScore = ''
      // this.tabRemove(this.$store.state.contentTabsActiveName)
    },
    previewImg1(url) {
        this.$hevueImgPreview({
          url,
          clickMaskCLose: true
        })
      },
    previewImg(url) {
        for (let i = 0; i < this.imgList.length; i++) {
          if (url == this.imgList[i]) {
            this.$hevueImgPreview(
              {
                multiple: true, // 开启多图预览模式
                nowImgIndex: i, // 多图预览，默认展示第二张图片
                imgList: this.imgList, // 需要预览的多图数组
                // url,
                clickMaskCLose: true
              })
          }
      }

    },
    aaa() {
      alert('niao1')
    },
    // 网盘点击
    openCloud(item) {
      window.open(item)
    },
    // 批量下载
    downAll() {
      console.log(this.allData);
      this.$request.post(`/course/homeworkDownload/addHomeworkDownLoad?courseId=${this.allData.courseId}&submitIds=${[this.allData.homeworkSubmitId]}`, {}).then((res) => {
        console.log(res)
        if (res) {
          this.homeworkDownIDS(res);
        }
      })
    },
    homeworkDownIDS(data) {
      this.submitLoading = true;
      console.log(data);
      this.$request
        .post(
          `/course/homeworkDownload/checkHomeworkDownloadIsOK?homeworkDownloadId=${data}`,
          {}
        )
        .then((res) => {
          if (res.downloadUrl == null) {
            setTimeout(() => {
              this.homeworkDownIDS(res.homeworkDownloadId);
            }, 1000);
          } else {
            // window.open(res.downloadUrl);
            this.dialogVisibleDownLoad = true;
            this.submitLoading = false;
            this.downloadUrl = res.downloadUrl;
            this.homeworkName = res.homeworkName;
          }
        });
    },
    homeworkDownIDSResult() {
      window.open(this.downloadUrl);
      this.dialogVisibleDownLoad = false;
    },
    // 时间格式化
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(date).format(format)
    },
    getData() {
      this.$request
        .post(
          `/course/homework/selectSubmit?homeworkSubmitId=${this.homeworkSubmitId}`,
          {}
        )
        .then((res) => {
          this.allData = {};
          this.allData = res;
          this.homeworkContent = JSON.parse(this.allData.homeworkContent);
          this.historyData = [];
          this.allData.approveDetailList.map((item, index) => {
            let i = {};
            i = {
              expansion: false,
              id: index,
              ...item
            }
            this.historyData.push(i);
          })
          if (this.allData.checkResult === 1) {
            this.markBtn = true
            this.checkResult = 1
          }
          this.planList = [];
          this.allData.homeworkContentVOList.map((item) => {
            if (item.contentType == 2) {
              this.imgList.push(item.content)
            }
          })
          let arr2 = this.allData.homeworkContentVOList.filter((item) => {
            return item.contentType == 1
          })
          this.planList.push({ type: 1, value: arr2 })
          let arr3 = this.allData.homeworkContentVOList.filter((item) => {
            return item.contentType == 4
          })
          this.planList.push({ type: 4, value: arr3 })
          let arr1 = this.allData.homeworkContentVOList.filter((item) => {
            return item.contentType != 1 && item.contentType != 4
          })
          this.planList.push({ type: 3, value: arr1 })
          console.log(this.planList, '123123')
        })
    },
  },
  created() {
    // 强制渲染组件
    this.allData = ''
    this.$forceUpdate()
    this.$eventHub.$on('show', (row) => {
      console.log(row, "rowshuju1================")
      const id = row.courseId
      this.homeworkSubmitId = id
      const data = row
      this.rowData = data
      console.log(this.homeworkSubmitId, 'homeworkSubmitId')
      console.log(this.rowData, 'this.rowData')
    })
    this.$eventHub.$on('courseId', (courseId) => {
      this.courseId = courseId
    })



    if (!this.courseId) {
      if (this.$route.query.courseId) {
        this.courseId = this.$route.query.courseId
      }
    }


    if (!this.homeworkSubmitId) {
      if (this.$route.query.show) {
        let show = JSON.parse(this.$route.query.show)
        this.homeworkSubmitId = show.homeworkSubmitId
        const data = show
        this.rowData = data
        if (this.rowData.homeworkCheck === 1) {
          this.markBtn = true
        }
        console.log(this.rowData, 'this.rowDatatttttt')
      }
    }

    this.getData()
  },

  components: {
    myVideo,
    ShowDetails,
    TableLine
  },
}
</script>
<style lang="scss" scoped>
.dialogVisibleReurnResource {
  width: 360px;
  height: 136px;
  background: #ffffff;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;

  .dialog-footer-btn {
    border-radius: 4px !important;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 6px;
    right: 9px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog__body {
    padding: 30px 20px;
    margin-top: -12px;
  }

  .el-dialog__footer {
    border: 0px !important;
    margin-top: -11px;
    margin-right: 15px;
  }

  .dialog-modl {
    height: 19px;
    display: flex;
    align-content: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      margin-left: 9px;
      margin-top: -18px;
    }

    .dialog-modl-right {
      width: 280px;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #252628;
      line-height: 24px;
      margin-top: -11px;
    }
  }
}
.padt5 {
  padding-left: 12px;
}
.grade-title1 {
  display: flex;
  column-gap: 5px;
  // margin-left: -12px;
}
.tableBox {
  border: 1px solid #DFE0E2;
  margin-top: 12px;
}
.fileIcon {
  width: 16px;
  position: relative;
  top: -2px;
}
.tableBox .titleBox {
  background: #FAFBFF;
  display: flex;
  flex-direction: row;
}

.tableBoxTitle {
  text-align: left;
  padding: 12px;
  flex: 1;
  font-size: 14px;
}

.tableBoxTitleFirst,
.tableBoxTitleLast {
  text-align: left;
  width: 120px;
  padding: 12px;
}

.tableBoxTitleLast {
  width: 80px;
}

 .el-upload .el-icon-document {
  color: #1C69D4;
}

.contentBox {
  display: flex;
  flex-direction: column;
  // border-top: 1px solid #DFE0E2;
  padding: 0 !important;
}

.tableLine {
  border-top: 1px solid #DFE0E2;
}

.contentLine {
  display: flex;
  flex-direction: row;
}

.contentDetails {
  display: none;
}

.lineBox {
  margin: 6px 0;
}

.lineBox1 {
  cursor: pointer;
  color: #1C69D4;
}

.lineBox:first-child {
  margin-top: 0;
}

.marking {

  width: 100%;
  height: 100%;

  .approval {
    height: 92px;
    border-radius: 4px;
    padding: 0 12px;
    background: #fff;
    margin-top: 15px;
    display: flex;
    align-items: center;

    .step {
      display: flex;
      flex-direction: column;
      align-content: center;
      width: 80px;
      margin-right: 200px;
      position: relative;
      align-items: center;
    }

    .step>.img {
      width: 28px;
      height: 28px;
      background: url('../../../../../assets/img/job/userSub.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      margin-bottom: 10px;
    }

    .step>.img0 {
      background: url('../../../../../assets/img/job/userSub.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img1 {
      background: url('../../../../../assets/img/job/diannei.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img2 {
      background: url('../../../../../assets/img/job/peixunshi.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img3 {
      background: url('../../../../../assets/img/job/userSub1.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img4 {
      background: url('../../../../../assets/img/job/diannei1.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img5 {
      background: url('../../../../../assets/img/job/peixunshi1.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img6 {
      background: url('../../../../../assets/img/job/peixunshi2.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>.img7 {
      background: url('../../../../../assets/img/job/peixunshi2.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }

    .step>img {
      width: 28px;
      margin-bottom: 10px;
    }

    .step1::after {
      content: " ";
      width: 200px;
      height: 1px;
      background: rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 12px;
      left: 80px;
    }

    .step:last-child {
      margin-right: 0;
    }

    .step:last-child::after {
      content: "";
      width: 0;
      height: 0;
    }
  }

  .statusBox {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background: #909399;
  }

  .statusSuccess {
    background: #67c23a;
  }

  .statusFail {
    background: #f56c6c;
  }

  .statusWarn {
    background: #e6a23c;
  }

  // 蓝色头
  .ess-information-title {
    display: flex;
    align-items: center;
    text-align: center;
    column-gap: 6px;
    padding: 8px 0 0 24px;

    .line {
      background-color: rgba(28, 105, 212, 1);
      width: 3px;
      height: 14px;
      margin-top: 4px;
    }

    .title {
      padding-top: 5px;
    }
  }

  // 隔离线
  .isolate {
    width: 97%;
    height: 1px;
    background: #0000001A;
    background-size: 100% 1px;
    margin: 12px 0 0 24px;
  }

  .marking-header-btn {
    height: 50px;
    width: 100%;
    background: #fff;

    .marking-header-btn-all {
      float: right;
      margin: 9px 12px 0 1px;

      .return {
        width: 76px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px !important;
        border: 1px solid #dfe0e2;
      }

      .save {
        width: 76px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #fff;
      }

      .marking {
        width: 76px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #fff;
      }

      .marking-end {
        width: 76px;
        height: 32px;
        background: #999A9CFF;
        border-radius: 4px !important;
        color: #fff;
      }

      .mark {
        margin: 0 -6px 0 -9px;
      }
    }
  }

  // 课程编号
  .marking-status {
    width: 100%;
    height: 88px;
    background: #fff;
    margin-top: 14px;

    .marking-status-content {
      display: flex;

      // 隔离线
      .image_1 {
        width: 1px;
        height: 48px;
        margin: 20px 0 0 39px;
      }

      //   隔离线
      .image_2 {
        width: 1px;
        height: 48px;
        margin: 20px 0 0 39px;
      }

      .marking-status-content-thired {
        display: flex;
        padding: 20px 0 21px 85px;
        flex-direction: column;
        width: 291px;

        .title {
          width: 60px;
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #999a9c;
          line-height: 22px;
        }

        .content {
          width: 227px;
          height: 22px;
          font-size: 14px;
          font-family: BMWTypeNextLatin-Regular, BMWTypeNextLatin, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 22px;
          display: flex;
          column-gap: 8px;
          align-items: center;
        }

        .back-content {
          width: 6px;
          height: 6px;
          border-radius: 5px;
        }
      }

      .marking-status-content-first {
        display: flex;
        padding: 20px 0 21px 24px;
        flex-direction: column;
        width: 22%;

        .title {
          width: 60px;
          height: 22px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #999a9c;
          line-height: 22px;
        }

        .content {
          width: 227px;
          height: 22px;
          font-size: 14px;
          font-family: BMWTypeNextLatin-Regular, BMWTypeNextLatin, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 22px;
          display: flex;
          column-gap: 8px;
          align-items: center;
        }

        .back-content {
          width: 6px;
          height: 6px;
          border-radius: 5px;
        }
      }

      .marking-status-content-second {
        width: 60%;
        display: flex;
        padding: 20px 0 21px 24px;
        white-space: nowrap;
        column-gap: 83px;
        .content-all {
          flex: 1;
          .title {
              width: 46px;
              height: 22px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #999a9c;
              line-height: 22px;
            }

            .content {
              width: 91px;
              height: 22px;
              font-size: 14px;
              font-family: BMWTypeNextLatin-Regular, BMWTypeNextLatin, sans-serif;
              font-weight: 400;
              color: #252628;
              line-height: 22px;
            }
        }


      }
    }
  }

  // 基本信息开始
  .ess {
    width: 100%;
    height: 171px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 17px;

    .ess-information {
      .ess-content {
        .content-first {
          display: flex;
          column-gap: 183px;
          padding: 24px 0px 20px 25px;
          white-space: nowrap;

          .moudle {
            display: flex;
            column-gap: 60px;

            .content-title {
              width: 28px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #999a9c;
              line-height: 20px;
            }

            .content-content {
              text-align: start;
              width: 160px;
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #252628;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  //基本信息结束

  // 作业描述开始
  .homework-depict {
    width: 100%;
    height: 243px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 17px;

    .depict-content {
      display: flex;
      margin: 24px 0 0 24px;
      column-gap: 16px;

      .depict-content-title {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999a9c;
        line-height: 20px;
      }

      .depict-content-content {
        width: 596px;
        height: 132px;
        background: #f2f4f5;
        border-radius: 4px;
        opacity: 0.5;
        border: 1px solid #dfe0e2;

        .content-text {
          padding: 12px 16px 12px 16px;
        }
      }
    }
  }

  //   作业描述结束

  // 作业内容开始
  .homework-content {
    padding: 0 0 16px 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 17px;
    padding-bottom: 51px;

    .content-all-text {
      display: flex;
      margin: 24px 0 0 24px;
      column-gap: 16px;

      .text-title {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999a9c;
        line-height: 20px;
      }

      .text-content {
        width: 596px;
        height: 132px;
        background: #f2f4f5;
        border-radius: 4px;
        opacity: 0.5;
        overflow-y: scroll;
        border: 1px solid #dfe0e2;
        overflow-x: hidden;
        word-wrap: break-word;

        .content-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #252628;
          line-height: 22px;
          padding: 12px 16px 12px 16px;
        }
      }
    }

    .content-all-pic {
      display: flex;
      margin: 16px 0 0 52px;
      column-gap: 16px;

      .pic-title {
        width: 28px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999a9c;
        line-height: 20px;
      }

      .pic-content {
        cursor: pointer;
        width: 294px;
        height: 134px;
        border-radius: 4px;
        border: 1px solid #dfe0e2;

        .content-pic {}
      }
    }

    .content-all-video {
      display: flex;
      margin: 16px 0 0 52px;
      column-gap: 16px;

      .video-title {
        width: 28px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999a9c;
        line-height: 20px;
      }

      .video-content {
        width: 294px;
        height: 134px;
        border-radius: 4px;
        border: 1px solid #dfe0e2;
      }
    }
  }

  // 附件下载开始
  .encl-download {
    width: 100%;
    height: 263px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 17px;

    .encl-download-all {
      margin: 24px 0 0 22px;

      .btn {
        width: 112px;
        height: 32px;
        background: #1c69d4;
        border-radius: 4px !important;
        color: #fff;
      }

      .download-all-content {
        margin-top: 20px;
      }
    }
  }

  // 附件下载结束

  // 作业审批开始
  .homework-processes {
    width: 100%;
    // height: 364px;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 17px;
    padding-bottom: 12px;

    .processes-result {
      display: flex;
      margin: 25px 0 0 24px;
      column-gap: 20px;

      .result-title {
        display: flex;
        column-gap: 5px;
      }
    }

    .processes-grade {
      display: flex;
      margin: 15px 0 0 23px;
      align-items: center;
      text-align: center;
      column-gap: 18px;

      .grade-title {
        display: flex;
        column-gap: 5px;
        margin-left: 30px;
      }

      .content {
        width: 498px;
        height: 32px;
        border-radius: 4px !important;
      }
    }

    .processes-reason {
      white-space: nowrap;
      width: 500px;
      display: flex;
      flex-direction: row;
      margin: 13px 0 0 36px;
      column-gap: 19px;

      .el-textarea__inner {
        min-height: 164.996px !important;
        width: 500px !important;
      }

      .el-textarea .el-input__count {
        bottom: 3px;
        right: 2px;
      }

      .el-textarea .el-input--medium {
        margin: 12px 0 12px 0 !important;
      }
    }

    .processes-upload {
      margin-left: 108px;

      .el-upload-list {
        width: 500px;
      }
    }
  }

  .el-textarea__inner {
    resize: none !important;
    border-radius: 4px !important;
  }

  .el-input__inner {
    border-radius: 4px !important;
  }
}

.viewItem {
  display: flex;
}

.viewItemIcon {
  line-height: 30px;
  margin-left: 6px;
  cursor: pointer;
  color: #1C69D4;
}



// 隔离线
.image-solate {
  width: 1px;
  height: 59px;
  background-size: 97% 1px;
  margin: 24px 0 0 24px;
  background-image: linear-gradient(#ccc 35%, rgba(255, 255, 255, 0) 0%);
  background-position: left;
  background-size: 1px 10px;
  background-repeat: repeat-y;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  margin-top: 10px;
  height: 8px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

// /*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
</style>
<style>
.processes-reason {
  white-space: nowrap;
  width: 500px;
  display: flex;
  flex-direction: row;
  margin: 13px 0 0 36px;
  column-gap: 19px;
  .el-textarea__inner {
    min-height: 164.996px !important;
    width: 500px !important;
    resize: none !important;
    border-radius: 4px !important;
  }
  .el-textarea .el-input__count {
    bottom: 3px;
    right: 2px;
  }
  .el-textarea .el-input--medium {
    margin: 12px 0 12px 0 !important;
  }
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  margin-top: 10px;
  height: 8px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
.dialogVisibleReurnResource {
  width: 360px;
  height: 136px;
  background: #ffffff;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
  0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}
  .dialog-footer-btn {
    border-radius: 4px !important;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 6px;
    right: 9px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 16px;
  }

  .el-dialog__body {
    padding: 30px 20px;
    margin-top: -12px;
  }

  .el-dialog__footer {
    border: 0px !important;
    margin-top: -11px;
    margin-right: 15px;
  }

</style>
